import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';

import {
	setModoTela, initForm
} from './incubacaoSelecaoActions';
import TextoInput from '../texto/textoInput';
import ClipboardImageHandler from '../common/form/ClipboardImageHandler';
import consts from '../consts';

class IncubacaoSelecaoForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir || this.props.visualizacao ? 'readOnly' : '';

		
		return (
			<Row alignCenter>
				<Grid cols='12 10 8 5'>
					<ContentCard 
						style={{
							marginTop: 20,
							backgroundColor: '#0F2748',
							color: '#ffffff',
							borderRadius: 20,
							boxShadow: '0px 0px 10px rgba(255, 255, 255, 0.9)',
							opacity: '80%'
						}}>
						<ContentCardHeader
							style={{
								marginTop: 16,
								marginBottom: 16
							}}>
							<label>{this.props.incubacaoSelecaoFormTitulo}</label>

							<TextoInput chave='incubacaoSelecaoFormTitulo' />

						</ContentCardHeader>
						<Form event={this.props.handleSubmit}>
							<ContentCardBody>
								<Row>

									<Field
										name='email'
										component={LabelAndInput}
										label='E-mail: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />

									<Field
										name='nome'
										component={LabelAndInput}
										label='Nome Completo: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='rg'
										component={LabelAndInputMask}
										label='RG: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										mask='99999999999' />

									<Field
										name='cpf'
										component={LabelAndInputMask}
										label='CPF: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										mask='999.999.999-99' />
									
									<Field
										name='endereco'
										component={LabelAndInput}
										label='Endereço: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='vinculo'
										component={Select}
										options={[
											{ id: 'Aluno Unijuí', valor: 'Aluno Unijuí' },
											{ id: 'Egresso', valor: 'Egresso' },
											{ id: 'Comunidade', valor: 'Comunidade' }
										]}
										label='Informe seu Vínculo: *' placeholder=''
										cols='12 12 12 12' />
									
									<Field
										name='onde_conheceu'
										component={Select}
										options={[
											{ id: 'Jornal', valor: 'Jornal' },
											{ id: 'Rádio', valor: 'Rádio' },
											{ id: 'Facebook', valor: 'Facebook' },
											{ id: 'Instagram', valor: 'Instagram' },
											{ id: 'LinkedIn', valor: 'LinkedIn' },
											{ id: 'Youtube', valor: 'Youtube' },
											{ id: 'Site', valor: 'Site' },
											{ id: 'Evento de empreendedorismo', valor: 'Evento de empreendedorismo' },
											{ id: 'Amigo/rede de contato', valor: 'Amigo/rede de contato' },
											{ id: 'Outro', valor: 'Outro' }
										]}
										label='Por onde conheceu a Criatec? *' placeholder=''
										cols='12 12 12 12' />

									<Field
										name='telefone'
										component={LabelAndInputMask}
										label='Telefone: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										mask='(99) 9 9999-9999' />
										
									<Field
										name='nome_empresa'
										component={LabelAndInput}
										label='Nome da Empresa: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									<Field
										name='descricao_negocio'
										component={LabelAndTextarea}
										label='Descreva o seu negócio em até 140 caracteres: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />

									<Field
										name='descricao_problema'
										component={LabelAndTextarea}
										label='Descreva o problema encontrado no mercado que pretende resolver, seja específico: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />
									
									<Field
										name='descricao_mercado'
										component={LabelAndTextarea}
										label='Descreva o tamanho do mercado e seu crescimentos, que percentual sua empresa pretende atender: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />
									
									<Field
										name='descricao_segmento'
										component={LabelAndTextarea}
										label='Descreva o segmento de clientes: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />
									
									<Field
										name='descricao_solucao'
										component={LabelAndTextarea}
										label='Descreva a solução, ou proposta de solução para esse problema: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />
									
									<Field
										name='descricao_receita'
										component={LabelAndTextarea}
										label='Descreva como pretende ganhar dinheiro, indicar fontes de receita: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />
									
									<Field
										name='faturamento'
										component={LabelAndTextarea}
										label='Quanto você faturou nos últimos 03 meses com essa solução? *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />
									
									<Field
										name='custos'
										component={LabelAndTextarea}
										label='Quais são os principais custos para os primeiros 06 meses? *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />
									
									<Field
										name='descricao_diferencial'
										component={LabelAndTextarea}
										label='Descreva o diferencial da solução: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />
									
									<Field
										name='descricao_vantagem_competitiva'
										component={LabelAndTextarea}
										label='Descreva a vantagem competitiva: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />
									
									<Field
										name='melhor_diferente'
										component={LabelAndTextarea}
										label='Por que você é melhor ou diferente: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />
									
									<Field
										name='descricao_realizado'
										component={LabelAndTextarea}
										label='Descreva o que fez até o momento: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />
									
									<Field
										name='conquistas'
										component={LabelAndTextarea}
										label='Quais foram as principais conquistas? *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />
									
									<Field
										name='metas'
										component={LabelAndTextarea}
										label='Quais as principiais metas para os próximos 06 meses? *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />
									
									<Field
										name='equipe'
										component={LabelAndTextarea}
										label='Descreva a sua equipe o papel de cada um no projeto, as competências técnicas e experiencias de cada um, e quanto tempo pretende dedicar ao desenvolvimento do negócio: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />
									
									<Field
										name='investimento'
										component={LabelAndTextarea}
										label='Você pretende captar investimentos? Quanto? *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />
									
									<Field
										name='investimento_onde'
										component={LabelAndTextarea}
										label='Descreva onde vais investir esse dinheiro? *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />
									
									<Field
										name='visao'
										component={LabelAndTextarea}
										label='Qual sua visão de futuro? *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />
									
									<Field
										name='proximo_passo'
										component={LabelAndTextarea}
										label='Qual é o seu próximo passo? *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />
									
									<Field
										name='porque_incubado'
										component={LabelAndTextarea}
										label='Descreva porquê deseja ser incubado? *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />
									
									{!this.props.excluir &&
									<Grid cols='12 12 12 12'
										style={{
											marginBottom: 12
										}}>

										<p>Anexar Pitch:</p>

										{(this.props.formularioValues.anexos || []).map(arquivo => (
											<div style={{ display: 'flex', flexDirection: 'column', padding: 10 }}>
												<span class="btn btn-outline-primary fileinput-button dz-clickable">
													<img src={pdfAdicionado} style={{ height: 30 }} />
												</span>
												<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
													<button
														type='button'
														class='btn btn-flat btn-primary'
														style={{ width: '48%' }}
														disabled={arquivo.arquivo_base64 ? true : false}
														onClick={() => {
															window.open(`${consts.URL}/${arquivo.arquivo}`, '_blank');
														}}>
														<i class='fas fa-download'></i>
													</button>
													<button
														type='button'
														class='btn btn-flat btn-danger'
														style={{ width: '48%' }}
														disabled={readOnly}
														onClick={() => {
															this.props.initForm({
																...this.props.formularioValues,
																anexos: this.props.formularioValues.anexos.filter(item => item != arquivo)
															});
														}}>
														<i class='fas fa-trash-alt'></i>
													</button>
												</div>
											</div>
										))}
										
										<ClipboardImageHandler
											label='Use Ctrl+V para colar ou arraste e solte anexos aqui.'
											msgErro='Selecione apenas (.PDF)'
											types={[
												'application/pdf'
											]}
											onChange={result => {

												let lista = (this.props.formularioValues.anexos || []).map(item => item);
												lista.push({
													arquivo_base64: result
												});
												this.props.initForm({
													...this.props.formularioValues,
													anexos: lista
												});
											}} />
									</Grid>}

								</Row>

								<Row alignCenter>
									{!this.props.visualizacao &&
									<Grid cols='8 8 8 8'>
										{this.props.excluir ? (
											<Button
												text='Excluir'
												submit type={'danger'}
												icon={'fa fa-trash'} />
										) : (!this.props.sessao.administrador ? (
											<Button
												text='Salvar'
												submit
												type={'success'}
												icon={'fa fa-check'} />
										) : null)}
									</Grid>}
									<Grid cols='4 4 4 4'>
										<Button
											text='Voltar'
											type={'success'}
											icon={'fa fa-chevron-left'}
											event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
									</Grid>
								</Row>
							</ContentCardBody>
						</Form>
					</ContentCard>
				</Grid>
			</Row>
		);
    }


}

IncubacaoSelecaoForm = reduxForm({form: 'incubacaoSelecaoForm', destroyOnUnmount: false})(IncubacaoSelecaoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('incubacaoSelecaoForm')(state),
	registro: state.incubacaoSelecao.registro,
	lista: state.incubacaoSelecao.lista,
	incubacaoSelecaoFormTitulo: state.texto.lista.filter(item => item.chave == 'incubacaoSelecaoFormTitulo').map(item => item.valor)[0],
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(IncubacaoSelecaoForm);
